export default __webpack_public_path__ + "static/true-grit-logo-00b16e2de8962d9e5646e4038d117da7.svg";